<template>
    <b-overlay :show="loading" rounded="sm">
        <b-card title="Excluir Conta">
            <b-form @submit="submit" @submit.stop.prevent>

                <div class="text-danger mb-2 text-sm">
                    Por favor, esteja ciente de que esta ação é irreversível e todos os seus dados serão apagados.
                    Se você tem certeza de que deseja continuar, entre com a sua senha para confirmar a exclusão.
                </div>

                <!-- Field -->
                <b-form-group
                    label="Senha">

                    <!-- Input -->
                    <b-form-input
                        type="password"
                        v-model="form.password"
                        :state="hasErrors('password', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="password" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="danger" :disable="loading">
                    Deletar Conta
                </b-button>
            </b-form>
        </b-card>
    </b-overlay>
</template>

<script>
export default {
    props: [],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                password: null
            }
        }
    },
    methods: {

        submit() {
            this.loading = true;
            axios.post('/student/configuration/destroy-account', this.form)
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

    }
}
</script>

<style scoped>

</style>
